<app-card-table
    translatePrefix="database.organizationAdministrationPage.addresses.table."
    [tableTitle]="'database.organizationAdministrationPage.addresses.table.title'"
    [showDetail]="isAllowed['organization.update']()"
    [showDelete]="isAllowed['organization.update']()"
    [columns]="columns"
    [items]="addresses()"
    [buttons]="buttons"
    (createCallback)="addressDialog()"
    (detailCallback)="addressDialog($event)"
    (deleteCallbackWithEvent)="deleteAddress($event)"
></app-card-table>

<ng-template #buttons>
    @if (addresses()?.[0]?.address) {
        <app-map-link-tag icon="pi-home" [address]="addresses()?.[0]?.address || null"></app-map-link-tag>
    }
</ng-template>
